import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";
import i18n from "../../../../i18n";
import ModalPortalHOC from "../../../../components/BaseComponents/ModalPortalHOC";
import DashboardPublishModal from "../DashboardPublish/DashboardPublishModal";
import DashboardInvitaUnAmico from "../InvitaUnAmico/DashboardInvitaUnAmico";

export class DashboardInvitaUnAmicoButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pageOpen: false
        }
    }

    handlePageOpen = _ => this.setState({pageOpen: true});
    handlePageClose = _ => this.setState({pageOpen: false});

    render() {
        return (
            <Fragment>
                <div className={"d-flex align-items-center justify-content-between p-3 border-top text-danger"} onClick={this.handlePageOpen}>
                    <span>
                        &#129297; &nbsp;
                        {i18n.t("launcher.side-menu.invita-amico")}
                    </span>
                    <span className={"badge badge-pill bg-success text-white"}>fino a €1000+ per te</span>
                </div>
                <ModalPortalHOC>
                    {/* Invita un amico */}
                    {
                        this.state.pageOpen &&
                        <DashboardInvitaUnAmico
                            id_negozio={parseInt(this.props.userNegozio.id_negozio)}
                            active={this.state.pageOpen}
                            onDismiss={this.handlePageClose}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        )
    }

}

DashboardInvitaUnAmicoButton.propTypes = {
    userNegozio: PropTypes.object
}